import { get } from 'lodash'
import { getAgentCountry } from '../reducers/fetchSsoReducers'

export const formatVPSCruiseRequestParams = (
  state,
  filterData,
  ssoAgent,
  shouldFetchCruiseTours
) => {
  const disabledBrands = get(state, 'ssoData.disabledBrands', [])
  const brand = filterData.brand
    .split(',')
    .filter(b => !disabledBrands.includes(b))
    .join(',')

  return {
    brand,
    bookingType: filterData.bookingType,
    cruiseType: shouldFetchCruiseTours ? 'CO,CT' : 'CO',
    currency: filterData.currency,
    startDate: filterData.startDate,
    endDate: filterData.endDate,
    count: filterData.count,
    duration: filterData.duration,
    page: filterData.page,
    voyageType: filterData.voyageType,
    ship: filterData.ship,
    seniorReqd: filterData.isSeniorCitizen,
    militaryReqd: filterData.isServiceMember,
    policeReqd: filterData.isPolice,
    fireFighterReqd: filterData.isFireFighter,
    agencyId:
      ssoAgent?.transactionData?.agencyId ?? ssoAgent?.agency?.agency_id,
    officeCode: get(ssoAgent, 'transactionData.officeCode', ''),
    occupancy: filterData.guestCount,
    country: getAgentCountry(state) || get(ssoAgent, 'agent.country', ''),
    loyaltyId: filterData.loyaltyId,
    loyaltyTierCode: filterData.loyaltyId ? filterData.loyaltyTier : '',
    region: filterData.region
  }
}

export const formatCruiseRequestParams = (
  state,
  filterData,
  ssoAgent,
  shouldFetchCruiseTours
) => {
  return {
    brand: filterData.brand,
    bookingType: filterData.bookingType,
    cruiseType: shouldFetchCruiseTours ? 'CO,CT' : 'CO',
    currency: filterData.currency,
    startDate: filterData.startDate,
    endDate: filterData.endDate,
    count: filterData.count,
    duration: filterData.duration,
    ship: filterData.ship,
    port: filterData.port,
    region: filterData.region,
    seniorReqd: filterData.isSeniorCitizen,
    militaryReqd: filterData.isServiceMember,
    policeReqd: filterData.isPolice,
    fireFighterReqd: filterData.isFireFighter,
    stateCode: filterData.residentOf,
    loyaltyId: filterData.loyaltyId,
    loyaltyTierCode: filterData.loyaltyId ? filterData.loyaltyTier : '',
    sso: filterData.sso,
    sortBy: filterData.sortBy,
    countryCode: getAgentCountry(state) || get(ssoAgent, 'agent.country', ''),
    agencyId:
      ssoAgent?.transactionData?.agencyId ?? ssoAgent?.agency?.agency_id,
    officeCode: get(ssoAgent, 'transactionData.officeCode', ''),
    occupancy: filterData.guestCount,
    country: getAgentCountry(state) || get(ssoAgent, 'agent.country', '')
  }
}
